module.exports = __webpack_public_path__ + "assets/media/sound8.fe835f7e.mp3";